<div *ngIf="is_loading">
	<div class="text-center">
		<div class="spinner-grow text-primary" role="status">
			<span class="sr-only"></span>
		</div>
	</div>
</div>
